import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import PeopleIcon from "@mui/icons-material/People";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import SchoolIcon from "@mui/icons-material/School";
import EmailIcon from "@mui/icons-material/Email";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import MapIcon from "@mui/icons-material/Map";

export const ADMIN_HUB_CARDS = [
    {
        icon: SupervisorAccountIcon,
        title: "Kursholderadministrasjon",
        description: "Administrer kursholdere, godkjenn nye søkere og oppdater kursholderregisteret.",
        path: "/administrate-instructors",
        buttonLabel: "Administrer kursholdere",
    },
    {
        icon: PeopleIcon,
        title: "Brukeradministrasjon",
        description: "Oversikt over alle registrerte brukerkontoer, rettigheter og rolletildeling.",
        path: "/admin/users",
        buttonLabel: "Administrer brukere",
    },
    {
        icon: LocalShippingIcon,
        title: "Bokbestillinger",
        description: "Oversikt over bestillinger av arbeidsbøker, leveringsadresser og ordrestatus.",
        path: "/admin/orders",
        buttonLabel: "Administrer bestillinger",
    },
    {
        icon: NewspaperIcon,
        title: "Nyhetsadministrasjon",
        description: "Opprett, rediger og administrer nyheter, faglige oppdateringer og kursdatoer.",
        path: "/admin/news",
        buttonLabel: "Administrer nyheter",
    },
    {
        icon: FormatQuoteIcon,
        title: "Tilbakemeldinger",
        description: "Administrer sitater og tilbakemeldinger fra kursholdere og kommuner på forsiden.",
        path: "/admin/testimonials",
        buttonLabel: "Administrer tilbakemeldinger",
    },
    {
        icon: SchoolIcon,
        title: "Kurslederopplæring",
        description: "Administrer sertifiseringskurs for fagfolk, samlinger og påmeldingsfrister.",
        path: "/admin/training",
        buttonLabel: "Administrer opplæring",
    },
    {
        icon: EmailIcon,
        title: "Send e-post til kursholdere",
        description: "Send felles e-post eller nyhetsoppdateringer direkte til alle kursholdere i nettverket.",
        path: "/send-email-to-instructors",
        buttonLabel: "Send e-post",
    },
];

export const QUICK_LINKS_CARDS = [
    {
        icon: MenuBookIcon,
        title: "Bestill kursbøker",
        description: "Bestill «Kurs i bekymringsmestring» bøker til deg selv eller dine kursdeltakere med faktura.",
        path: "/order-books",
        buttonLabel: "Gå til bestilling",
    },
    {
        icon: MapIcon,
        title: "Kursholderkartet",
        description: "Se det interaktive norgeskartet med alle autoriserte kursholdere fordelt på fylker.",
        path: "/find-instructor",
        buttonLabel: "Se kartet",
    },
];
